import vehicles from '../../common/adhesion/vehicles.vue'
import * as obj from '../../common/adhesion/objects'
import Sales from '../../../services/sales'
import Auth from '../../../services/auth'
import Contracts from '../../../services/contracts'
import Account from '../../../services/account'
import C from '../../common/constantes'
import GenericSummary from '../../common/generic-summary.vue'
import successPage from '../../common/adhesion/success.vue'
import errorPage from '../../common/adhesion/error.vue'
import addressComp from "../../common/address.vue"
import messageDialog from "../../../components/message-dialog.vue";
import {
  EventBus
} from '../../../event-bus';
import * as Utils from '../../../utils'

const subs = ['Cadastre os veículos que irão utilizar o plano:', 'Revise os dados e confirme a solicitação:'];

export default {
  data() {
    return {
      contract: obj.contract(),
      newVehicleTax: undefined,
      vehicles: [],
      planId: undefined,
      planName: undefined,
      step: 0,
      subtitle: subs,
      msgError: undefined,
      loading: undefined,
      success: false,
      code: undefined,
      boletoUrl: undefined,
      changeAddress: false,
      newAddress: Auth.currentUser.address,
      qtdAllowed: C.LIMIT_VEHICLES,
      guaranteeTax: undefined,
      lead: undefined,
      total: undefined,
      promotionCode: undefined,
      contract: undefined,
      salesOrder: undefined,
      address: undefined,
      whereToDelivery: "0",
      shipmentType: undefined,
      novoCartao: false,
      salesResponse: undefined,
      sales:undefined,
      receberAccount:undefined,
      validacaoFraude: undefined,
      isMobile:false,
      cpm: {},
      cmpIdId: undefined,
      usuario: undefined,
      validado: undefined,
      tagSerialNumber: "",
      tagInHandActivated: false,
      tagInHandVehiclesKey: 0
    }
  },

  computed: {

    contractId() {
      return this.$route.params.contractId
    },
    user() {
      return Auth.currentUser
    },
    addressInit() {
      return Auth.currentUser.address;
    },
    tagActivationSuccessMessage() {
      const salesType = this.salesOrder && this.salesOrder.salesType;
      return salesType === 'REPLACETAG'
        ? C.MSG_01_REPLACE_IN_HAND_SUCCESS
        : 'TAG ativada com sucesso!';
    },
    isReplaceTagFlow() {
      return this.salesOrder && this.salesOrder.salesType === 'REPLACETAG';
    },

    request() {
      let vm = this;
      let request = {
        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
        account: vm.account,
        addresses: {
          address: [
            vm.address
          ]
        },
        contract: vm.contract,
        listVehicle: {
          vehicle: vm.vehicles
        },
        value: this.total,
        shipmentType: this.shipmentType
      };
      return request;
    }
  },

  created() {
    EventBus.$on('cleanErrors', () => {
      this.msgError = undefined;
    });

  },

  mounted: function () {

      if(window.innerWidth <= 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
     window.addEventListener('resize', () => window.innerWidth <= 769 ? this.isMobile = true : this.isMobile = false );
    let vm = this;
    if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/etapa1');
    this.loading = Contracts.getContractByContractId(this.contractId).then(r => {
      this.planId = r.plan.planId;
      this.contract = r;
      this.getPlanInfo();
      this.qtdAllowed -= r.countVehicle;
    }).then(res => {
      if (Utils.isCaminhoParana(this.planId)) {
        Sales.getLead({
          taxpayerIdNumber: Auth.currentUser.taxIdNumber
        }).then(response => {

          if (response.lead || response.status.code == 0) { //&& response.lead.status == constantes.CAMINHOS_PARANA_CADASTRADO
            response.lead.typeTaxId = Auth.currentUser.company ? 'COMPANY' : 'PERSON';
            this.lead = response.lead;
            this.lead.plates = this.lead.listVehicle.toUpperCase().replace(/(\w{3})(\d{4})/g, '$1-$2').split(/;/);
          }
        }).catch((error) => {

          this.errorMessage = error.data && `${_self.typePerson == 'PERSON' ? 'Cpf' : 'Cnpj'} não cadastrado no caminhos do Paraná!` || error.response && error.response.data.status.message;

        });
      }
    });
  },

  methods: {
    startRequest() {

      this.$refs.GenericSummary.getInfos().then(r => {

        this.address = r.address;
        this.promotionCode = r.promotionCode;
        this.whereToDelivery = r.whereToDelivery;
        this.shipmentType = r.shipmentType;
        this.tagSerialNumber = r.tagSerialNumber;
        this.doRequest();


      });
    },
    onShipmentTypeChange(shipmentType) {
      this.shipmentType = shipmentType;
    },
    onTagActivationState(activated) {
      this.tagInHandActivated = activated === true;
    },
    addAnotherVehicle() {
      if (this.tagInHandActivated) {
        this.vehicles.splice(0, this.vehicles.length);
        this.tagSerialNumber = "";
        this.shipmentType = undefined;
        this.tagInHandVehiclesKey += 1;
      }
      this.tagInHandActivated = false;
      this.step = 0;
      this.msgError = undefined;
      $('body').stop().animate({ scrollTop: 0 }, '500', 'swing');
    },
    finalizeTagInHandFlow() {
      this.$router.push({ name: 'plans' });
    },
    nextStep() {
      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      switch (this.step) {
        case 0:
          if (this.vehicles.length > 0) {

            let value = this.vehicles.length * this.newVehicleTax + this.vehicles.length * this.guaranteeTax;
            this.salesOrder = {
              "_interface": "WEBSITE",
              "planId": this.planId,
              "status": null,
              "type": "ADESÃO VEÍCULO ADICIONAL",
              "salesType": "ADHESIONVEHICLEADDITIONAL",
              "taxpayerIdSeller": null,
              "promotionCode": this.promotionCode,
              "price": value,
              "logisticsDistribution": null,
              "bankBillUrl": null,
              "transactionPassageId": null,
              "vehicleId": null,
              "contract": this.contractId,
              "shipment": null,
              "vehicles": this.vehicles,
              "products": [{
                "productId": 4,
                "productName": "ADESÃO VEÍCULO ADICIONAL",
                "valueUnit": this.newVehicleTax,
                "quantity": this.vehicles.length,
                "valueTotal": value
              }],
            };

            if (Utils.isCaminhoParana(this.planId)) {
              this.salesOrder["promotionCode"] = "CAMINHOSDOPARANA";
              this.salesOrder["logisticsDistribution"] = "FOB";
            }

            this.sendPageView();
            this.step += 1;

          } else
            this.msgError = 'Adicione ao menos um veículo para continuar';
          break;
      }
    },
    backStep() {
      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      if (this.changeAddress)
        this.changeAddress = false;
      else
        this.step -= 1;
    },

    sendPageView() {
      if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/etapa' + (this.step + 2));

    },

    cancelar() {

      messageDialog.show({
        title: 'Cancelar Novo Veículo',
        message: 'Deseja cancelar a adesão de novo veiculo?',
        type: 'OK-CANCEL-ADHESION'
      }).then(res => {
        if (res == 'OK') {
          if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/cancelou');
          this.$router.push({
            name: 'plans'
          });
        }
      });

    },
    getPlanInfo() {
      this.loading = Sales.getPlanById(this.planId)
        .then(resp => {

          if (this.planId == C.PLAN_POS || this.contract.adhesionTax) {
            this.newVehicleTax = this.contract.deadlineExemptionAdhesion > 0 ? 0 : this.contract.adhesionTax;
          } else {
            this.newVehicleTax = _.filter(resp.adhesionTax.adhesionTax, (o) => {

              return o.taxId == C.NEW_VEHICLE_TAXID
            })[0].value;
          }

          if (this.planId == 33 || this.planId == 34) {
            this.guaranteeTax = _.filter(resp.adhesionTax.adhesionTax, (o) => {
              return o.taxId == C.GUARANTEE_TAXID
            })[0].value;

          } else {
            this.guaranteeTax = 0;
          }

          this.planName = resp.name;

        });
    },

    doRequest() {

      let value = this.vehicles.length * this.newVehicleTax + this.vehicles.length * this.guaranteeTax;

      let req = {
        "contractId": this.contractId,
        "deliveryAddressId": this.address.addressId,
        "value": value,
        "promotionCode": this.promotionCode,
        "secureCode": this.user.taxIdNumber.substring(0, 4),
        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
        "vehicles": this.vehicles,
        "shipmentType": this.shipmentType
      };

      let url_atual = window.location.href;

      if (url_atual != "") {
        var regexp = new RegExp(/\S+pdv\S+/i);
        var n = regexp.test(url_atual);
        if (n) {
          req["promotionCode"] = "GRAALKM29";
          req["logisticsDistribution"] = "FOB";
        }
      }

      if (Utils.isCaminhoParana(this.planId)) {
        req["promotionCode"] = "CAMINHOSDOPARANA";
        req["logisticsDistribution"] = "FOB";
      }

      if (this.whereToDelivery != "0") {
        req["promotionCode"] = this.getwhereToDelivrey;
        req["logisticsDistribution"] = "FOB";
      }

      if (this.promotionCode) {
        req.promotionCode = this.promotionCode;
      }

      if(req.shipmentType == 3){
        req.logisticsDistribution = "FOB";
      }
      if (req.shipmentType == 4) {
        req.logisticsDistribution = null;
        req.value = 0;
        req.sales_type = "SOL_TAG";
      }

      if (req.shipmentType == 4 && this.tagSerialNumber && this.vehicles && this.vehicles.length) {
        this.vehicles[0].tagSerialNumber = this.tagSerialNumber;
      }

      let p = Sales.adhesionVehicleAddition(req).then(r => {
        if (r && r.status === 0 && r.salesToken) {
          window.location.href = r.salesToken;
          return new Promise(() => {});
        }
        if (r && r.status === 0 && (r.price === 0 || r.approved === true)) {
          if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/sucesso');
          this.code = 0;
          $('body').stop().animate({ scrollTop: 0 }, '500', 'swing');
          return;
        }
        this.usuario = r.salesOrder.contractPaymentMethod.usuario;
        this.validado = r.salesOrder.contractPaymentMethod.validado;
        var pedido = r.salesOrder.salesOrderId.toString();

        if (r.salesOrder && r.salesOrder.pixCopiaCola) this.pixCopiaCola = r.salesOrder.pixCopiaCola;

        if (this.cpm.paymentMethod.paymentMethodId == 120 && this.pixCopiaCola != undefined){
          this.newPix = true;
          this.salesResponse = r.salesOrder;
          this.code = r.status.code;
          this.boletoUrl = r.boletoUrl;
          this.cmpId = this.cpm.paymentMethod.paymentMethodId;
        } else if (this.cpm.paymentMethod.paymentMethodId == 120) {
          this.cmpId = this.cpm.paymentMethod.paymentMethodId;
          if (window.location.hostname == "www.movemais.com" || window.location.hostname == "movemais.com" || r.status.info_cc == "8910024294252017") {
            this.vads_ctx_mode = "PRODUCTION";
          }
          else {
            this.vads_ctx_mode = "TEST";
          }

          this.vads_trans_date = new Date(r.salesOrder.salesDate).toISOString().replace(/[^0-9]/g, '').substring(0, 14);
          this.vads_trans_id = "M"+pedido.slice(-5);
          this.vads_order_id = r.salesOrder.salesOrderId;
          this.vads_amount = r.salesOrder.price;
          this.vads_site_id = r.status.info_st;
          this.certificate = r.status.info_cc;
          this.vads_order_info = r.status.info_cp;

          if (this.user.person) {
            var sobrenome = this.user.person.lastName.split(" ", 2);
            this.vads_cust_first_name = this.user.person.name;
            this.vads_cust_last_name = sobrenome[0];
            this.vads_cust_name = this.user.person.name;
          } else if (this.user.company) {
            var nome = this.user.company.companyTradeName.split(" ", 2);
            this.vads_cust_first_name = nome[0];
            this.vads_cust_last_name  = nome[1] ? nome[1] : nome[0];
            this.vads_cust_name = nome[0];
          }
          this.vads_cust_national_id = this.user.taxIdNumber;
          this.vads_cust_email = this.user.accountAuthentication.login;

          this.ReceberHash();

          this.newPix = true;
          setTimeout(() => {
            document.getElementById("formPix").submit();
            this.salesResponse = r.salesOrder;
            this.code = r.status.code;
            this.boletoUrl = r.boletoUrl;
          }, 200);
        }else{
          this.salesResponse = r.salesOrder;
          this.code = r.status.code;
          this.boletoUrl = r.boletoUrl;
        if (r.redirUrl || r.bankBillUrl) {
            return messageDialog.show({
              title: "Estamos quase lá...",
              headerClass: 'modal-success',
              message: r.status.message
            })
            .then(res => {
              if (r.redirUrl) {
                window.location = r.redirUrl;
              }

            });
        }

        if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/sucesso');
        $('body').stop().animate({
          scrollTop: 0
        }, '500', 'swing');
        //this.$router.push({name: 'login'});
      } }).catch(err => {
        this.cmpId = this.cpm.paymentMethod.paymentMethodId;
        if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/erro');
        const data = (err && err.data) || {};
        const status = data.status || {};
        this.code = status.code;
        this.msgError = status.message || data.message;
        this.salesResponse = undefined;
        this.usuario = undefined;
        this.validado = undefined;
        this.cmpId = undefined;
        $('body').stop().animate({
          scrollTop: 0
        }, '500', 'swing');
      });

      this.$store.dispatch('loading', p);

    },

    goToStep(value) {
      this.code = undefined;
      this.step = value;
    },
    saveAddress() {
      this.$refs.addressMailing.$validator.validateAll()
        .then((success) => {
          this.loading = Account.updateAddress(this.newAddress)
            .then(r => {
              this.changeAddress = false;
              let user = Auth.currentUser;
              user.address = this.newAddress;
              Auth.currentUser = user;
            })
            .catch((err) => {
              messageDialog.show({
                title: 'Erro',
                message: err.data.status.message,
                headerClass: 'modal-danger'
              });
            });
        });
    },
    eventChangeAddress(newValue) {
      this.changeAddress = newValue;
    },
    setTotal(t) {
      this.total = t;
    },
    changePromotionCode(newValue) {
      this.promotionCode = newValue;
    }

  },
  beforeDestroy() {

    EventBus.$off('cleanErrors');
  },

  components: {
    vehicles,
    successPage,
    errorPage,
    addressComp,
    GenericSummary
  }
}




// WEBPACK FOOTER //
// ./src/pages/account/vehicle/new-vehicle.js